import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "current", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2.5, d: "M20 7L10 17l-5-5" }));
export default SvgCheck;
